import React from 'react';
import { useWidget } from '../useWidget';
import { Button } from 'antd';
import Icon from '@mdi/react';
import { mdiPlusCircle } from '@mdi/js';
import { Link } from 'react-router-dom';

const WidgetEmptyState = ({ children }) => {
  const { connectToGetDataButton, widgetEmptyStateProps } = useWidget();

  return (
    <div className='w-full top-0 left-0 botto-0 right-0 h-full'>
      <div className='w-full h-full' style={{ filter: 'blur(2px)' }}>
        {children}
      </div>

      <div
        className='absolute rounded-md inset-0 z-10'
        style={{ background: 'rgb(245 245 245 / 43%)' }}
      />
      {connectToGetDataButton && (
        <div className='absolute inset-0 z-20 flex items-center justify-center'>
          <div className='shadow-xl rounded-full'>
            <Link to={widgetEmptyStateProps.redirectLink}>
              <Button
                size='large'
                type='primary'
                className='!rounded-full !!text-base !font-normal'
                icon={<Icon path={mdiPlusCircle} size={0.8} />}
              >
                {widgetEmptyStateProps.buttonText}
              </Button>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default WidgetEmptyState;
